import DashboardRoute from "./modules/MortgageDashboard";
import ManageContactsRoute from "./modules/MortgageContacts";
import ManageConnectionsRoute from "./modules/MortgageConnections";


export const MortgageDashboard = DashboardRoute
export const MortgageContacts = ManageContactsRoute
export const MortgageConnections = ManageConnectionsRoute
